/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import { MapTo, Container } from '@adobe/aem-react-editable-components';
import {
  EditableHTLWrapper,
  StaticWrapper,
  BrandRibbon,
  Hero,
  CardHorizontalFeature,
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
  CardHorizontalMini,
  CardLayered,
  CardCarouselContainer,
  CardVertical,
  TabContainer,
  VariableColumnContainer,
  Text,
  IconBlock,
  DataBlock,
  AccordionContainerEnhanced,
  RichText,
  DynamicWrapper,
} from '@marriott/mi-common-static-components';
import {
  MemberStatusEditable,
  AccountNavbarEditable,
  ExtendedFooterEditable,
  SavedHotelsDetailsEditable,
  MyActivityEditable,
  ReportMissingStayLinkSectionEditable,
  EarnedRewardsEditable,
  EarningsSummaryEditable,
  MissingStayRequestFormEditable,
  ReportMissingStayRequestConfirmationEditable,
  UpcomingTripsEditable,
  CancelledTripsEditable,
  TripsNavigationEditable,
  FindReservationOverlayEditable,
  CreateAccountEditable,
  TargetBannerEditable,
  SignInEditable,
  SignInContentBlockEditable,
  SignOutEditable,
  ConfirmIdentityEditable,
  AccountContainerEditable,
  RegisteredPromotionsEditable,
  NewPromotionsEditable,
  PromotionBannerEditable,
  ActivateOrForgotFormEditable,
  LoyaltyWidgetContainerEditable,
  SetPasswordEditable,
  ForgotPasswordEmailSentEditable,
  GlobalEAAHeaderEditable,
  PromotionNotAvailableEditable,
  ConsentFormEditable,
  PromotionDetailsEditable,
  SignInAppBannerEditable,
  MemberSnapshotRibbonEditable,
  OnboardingSectionEditable,
  CustomTitleTextEditable,
  NightsDetailEditable,
  ChangePasswordEditable,
  ForceChangePasswordEditable,
  AccountOverviewNotificationEditable,
  OverviewOffersEditable,
  SweepstakesEnrollmentEditable,
  CreateAccountConsentsFormEditable,
  ProfileSectionEditable,
  OneClickJoinContainerEditable,
  CombineAccountsEditable,
  CombineAccountsConsentEditable,
  FoodBevPreferenceEditable,
  EditPersonalInformationEditable,
  BannerMessagesEditable,
  FolioOptionsEditable,
  TwoStepVerificationEditable,
  AmbassadorElitePreferencesEditable,
  InterestsAndHobbiesEditable,
  AmbassadorServiceDetailsEditable,
  EditChangePasswordEditable,
  CommunicationPreferenceEditable,
  RoomPreferencesEditable,
  EarningAndRewardsEditable,
  AddCardEditable,
  ModifyUpgradeReqHeaderEditable,
  UpdateRoomSelectionEditable,
  CancelUpgradeRequestEditable,
  PointsTransferEditable,
  EmailUnsubscribeEditable,
  LookUpMemberNumberEditable,
  AccountTableEditable,
  AccountStaticWrapperEditable,
  AccountPartnerCardWrapperEditable,
  PartnerCardEditable,
  AccountMetricsEditable,
  AccordionCardWrapperEditable,
  LoyaltyCompassEditable,
  MembershipBenefitsEditable,
  TrustedDevicesEditable,
  AddGiftCardEditable,
  ViewGiftCardEditable,
  VerifiedSpecialRatesEditable,
  AccountStickyLeftRailContainerEditable,
  WalletWidgetEditable,
  AccountRefreshNotificationEditable,
} from '@marriott/mi-account-components';
import {
  RoomDetailsModalEditable,
  RoomDetailsModalEditableMGP,
  CurrentReservationDetailsEditable,
  CurrentReservationDetailsEditableMGP,
  HotelHeaderV2Editable,
  HotelHeaderV2EditableMGP,
  ErrorMessageEditable,
  HQVModalEditable,
  FlyoutDrawer,
  HQVModalEditableMGP,
} from '@marriott/mi-book-components';
import {
  MerchandisingSmallBanner,
  MerchandisingCarouselContainer,
  MerchandisingCardTile,
  DCADecisionContainer,
  MerchandisingMangoPilot,
  MerchandisingPartnerCard,
  RiottMediaCard,
  MerchandisingTileSkinny,
} from '@marriott/mi-merch-components';
import { respGridUtil } from '@marriott/mi-headless-utils';
import { HeroBanner } from '@marriott/mi-homepage-components';
import { NavigationMenu } from '@marriott/mi-groups-components';
import { SearchFormEditable } from '@marriott/mi-shop-components';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/DataPage';
import '../../libs/aemComponents/ExperienceFragment';

export const AEM_REACT_MAPPING = {
  [`mi-aem-common-spa/components/common/staticwrapper`]: StaticWrapper,
  [`mi-aem-common-spa/components/content/brandribbon`]: BrandRibbon,
  ['mi-aem-common-spa/components/content/hero']: Hero,
  ['mi-aem-common-spa/components/content/cardhorizontalfeature']: CardHorizontalFeature,
  [`mi-aem-account/components/content/memberStatus`]: MemberStatusEditable,
  [`mi-aem-account/components/content/accountNavbar`]: AccountNavbarEditable,
  [`mi-aem-account/components/content/extendedFooter`]: ExtendedFooterEditable,
  [`mi-aem-account/components/content/savedHotelsDetails`]: SavedHotelsDetailsEditable,
  [`mi-aem-account/components/content/myActivity`]: MyActivityEditable,
  [`mi-aem-account/components/content/earnedRewards`]: EarnedRewardsEditable,
  [`mi-aem-account/components/content/earningssummary`]: EarningsSummaryEditable,
  [`mi-aem-account/components/content/missingStayRequest`]: ReportMissingStayLinkSectionEditable,
  [`mi-aem-account/components/content/missingstayrequestform`]: MissingStayRequestFormEditable,
  [`mi-aem-account/components/content/missingstayrequestconfirmation`]: ReportMissingStayRequestConfirmationEditable,
  [`mi-aem-account/components/content/upcomingtrips`]: UpcomingTripsEditable,
  [`mi-aem-account/components/content/cancelledtrips`]: CancelledTripsEditable,
  [`mi-aem-account/components/content/tripsnavigation`]: TripsNavigationEditable,
  [`mi-aem-account/components/content/datapagecomponent`]: Container,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  [`mi-aem-account/components/content/findreservation`]: FindReservationOverlayEditable,
  [`mi-aem-account/components/content/createaccount`]: CreateAccountEditable,
  [`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`]: TargetBannerEditable,
  [`mi-aem-account/components/content/signin`]: SignInEditable,
  [`mi-aem-account/components/content/signincontentblock`]: SignInContentBlockEditable,
  [`mi-aem-account/components/content/signout`]: SignOutEditable,
  [`mcom-book-spa/components/flyoutcontainer`]: FlyoutDrawer,
  [`mi-aem-account/components/content/confirmidentity`]: ConfirmIdentityEditable,
  [`mi-aem-account/components/content/accountcontainer`]: AccountContainerEditable,
  [`mi-aem-account/components/content/newpromotions`]: NewPromotionsEditable,
  [`mi-aem-account/components/content/promotionbanner`]: PromotionBannerEditable,
  [`mi-aem-account/components/content/registeredpromotions`]: RegisteredPromotionsEditable,
  [`mi-aem-account/components/content/activateorforgotform`]: ActivateOrForgotFormEditable,
  [`mi-aem-account/components/content/setpassword`]: SetPasswordEditable,
  [`mi-aem-account/components/content/forgotpasswordemailsent`]: ForgotPasswordEmailSentEditable,
  [`mi-aem-account/components/content/eaaglobalheader`]: GlobalEAAHeaderEditable,
  [`mi-aem-account/components/content/promotionnotavailable`]: PromotionNotAvailableEditable,
  [`mi-aem-account/components/content/consentform`]: ConsentFormEditable,
  [`mi-aem-account/components/content/promotiondetails`]: PromotionDetailsEditable,
  [`mi-aem-account/components/content/signinappbanner`]: SignInAppBannerEditable,
  [`mi-aem-account/components/content/membersnapshotribbon`]: MemberSnapshotRibbonEditable,
  [`mi-aem-account/components/content/onboardingsection`]: OnboardingSectionEditable,
  [`mi-aem-account/components/content/overviewoffers`]: OverviewOffersEditable,
  [`mi-aem-account/components/content/customtitletext`]: CustomTitleTextEditable,
  [`mi-aem-account/components/content/nightsdetail`]: NightsDetailEditable,
  [`mi-aem-account/components/content/changepassword`]: ChangePasswordEditable,
  [`mi-aem-account/components/content/forcechangepassword`]: ForceChangePasswordEditable,
  [`mi-aem-account/components/content/accountoverviewnotification`]: AccountOverviewNotificationEditable,
  [`mi-aem-account/components/content/sweepstakesenrollment`]: SweepstakesEnrollmentEditable,
  [`mi-aem-account/components/content/createaccountconsentform`]: CreateAccountConsentsFormEditable,
  [`mi-aem-account/components/content/oneclickjoinreservation`]: OneClickJoinContainerEditable,
  [`mi-aem-homepage-spa/components/content/herobanner`]: HeroBanner,
  [`mi-aem-account/components/content/profilesection`]: ProfileSectionEditable,
  [`mi-aem-account/components/content/combineaccounts`]: CombineAccountsEditable,
  [`mi-aem-account/components/content/combineaccountsconsent`]: CombineAccountsConsentEditable,
  [`mi-aem-account/components/content/foodbevpreferences`]: FoodBevPreferenceEditable,
  [`mi-aem-account/components/content/editpersonalinformation`]: EditPersonalInformationEditable,
  [`mi-aem-account/components/content/bannermessages`]: BannerMessagesEditable,
  [`mi-aem-account/components/content/foliooptions`]: FolioOptionsEditable,
  [`mi-aem-account/components/content/twostepverification`]: TwoStepVerificationEditable,
  [`mi-aem-account/components/content/ambassadorelitepreferences`]: AmbassadorElitePreferencesEditable,
  [`mi-aem-account/components/content/communicationpreference`]: CommunicationPreferenceEditable,
  [`mi-aem-account/components/content/earningandrewards`]: EarningAndRewardsEditable,
  [`mi-aem-account/components/content/interestsandhobbies`]: InterestsAndHobbiesEditable,
  [`mi-aem-account/components/content/ambassadorservicedetails`]: AmbassadorServiceDetailsEditable,
  [`mi-aem-account/components/content/addcard`]: AddCardEditable,
  [`mi-aem-account/components/content/loyaltywidgetcontainer`]: LoyaltyWidgetContainerEditable,
  [`mi-aem-account/components/content/editchangepassword`]: EditChangePasswordEditable,
  [`mi-aem-account/components/content/roomPreferences`]: RoomPreferencesEditable,
  [`mi-aem-account/components/content/modifyupgraderequestheader`]: ModifyUpgradeReqHeaderEditable,
  [`mi-aem-account/components/content/updateroomselection`]: UpdateRoomSelectionEditable,
  [`mi-aem-account/components/content/cancelupgraderequest`]: CancelUpgradeRequestEditable,
  [`mcom-book-spa/components/foundation/roomdetails`]: RoomDetailsModalEditable,
  [`mcom-book-spa/components/foundation/roomdetails`]: RoomDetailsModalEditableMGP,
  [`mcom-book-spa/components/modifyratelistmenu/currentreservationdetails`]: CurrentReservationDetailsEditable,
  [`mcom-book-spa/components/modifyratelistmenu/currentreservationdetails`]: CurrentReservationDetailsEditableMGP,
  [`mi-aem-account/components/content/pointstransfer`]: PointsTransferEditable,
  [`mi-aem-account/components/content/emailunsubscribe`]: EmailUnsubscribeEditable,
  [`mcom-book-spa/components/prebooking/hotelheader`]: HotelHeaderV2Editable,
  [`mcom-book-spa/components/prebooking/hotelheader`]: HotelHeaderV2EditableMGP,
  [`mcom-book-spa/components/foundation/errormessage`]: ErrorMessageEditable,
  [`mi-aem-account/components/content/lookupmembernumber`]: LookUpMemberNumberEditable,
  [`mi-aem-common-spa/components/content/globalnav/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-common-spa/components/content/globalnav/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-common-spa/components/content/globalnav/primaryNavigation`]: NavigationWrapper,
  [`mi-aem-common-spa/components/common/dynamicwrapper`]: DynamicWrapper,
  [`mi-aem-account/components/content/accounttable`]: AccountTableEditable,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: CardHorizontalMini,
  [`mi-aem-common-spa/components/content/cardlayered`]: CardLayered,
  [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: CardCarouselContainer,
  [`mi-aem-common-spa/components/content/cardvertical`]: CardVertical,
  [`mi-aem-common-spa/components/content/tabcontainer`]: TabContainer,
  [`mi-aem-common-spa/components/content/variablecolumncontainer`]: VariableColumnContainer,
  [`mi-aem-common-spa/components/content/text`]: Text,
  [`mi-aem-common-spa/components/content/richtext`]: RichText,
  [`mi-aem-common-spa/components/content/iconblock`]: IconBlock,
  [`mi-aem-common-spa/components/content/datablock`]: DataBlock,
  [`mi-aem-shop-spa/components/content/homepagesearch/v1/homepagesearch`]: SearchFormEditable,
  [`mi-aem-shop-spa/components/content/baselinesearchform/v1/baselinesearchform`]: SearchFormEditable,
  [`mi-aem-common-spa/components/content/accordioncontainerenhanced`]: AccordionContainerEnhanced,
  [`mi-aem-account/components/content/accountwrapper`]: AccountStaticWrapperEditable,
  [`mi-aem-account/components/content/partnercardwrapper`]: AccountPartnerCardWrapperEditable,
  [`mcom-book-spa/components/hoteloverlay/hqvmodal`]: HQVModalEditable,
  [`mcom-book-spa/components/flyoutcontainer`]: FlyoutDrawer,
  [`mcom-book-spa/components/hoteloverlay/hqvmodal`]: HQVModalEditableMGP,
  [`mi-aem-groups/components/content/shoppingpages/sectionnavigationv2`]: NavigationMenu,
  [`mi-aem-account/components/content/partnercard`]: PartnerCardEditable,
  [`mi-aem-account/components/content/accountmetrics`]: AccountMetricsEditable,
  [`mi-aem-account/components/content/accordion`]: AccordionCardWrapperEditable,
  [`mi-aem-account/components/content/membershipbenefits`]: MembershipBenefitsEditable,
  [`mi-aem-account/components/content/addgiftcard`]: AddGiftCardEditable,
  [`mi-aem-account/components/content/viewgiftcard`]: ViewGiftCardEditable,
  [`mi-aem-common-spa/components/content/tilesquare`]: MerchandisingCardTile,
  [`mi-aem-common-spa/components/content/tilecarouselcontainer`]: MerchandisingCarouselContainer,
  [`mi-aem-common-spa/components/content/merchandisingsmallbanner`]: MerchandisingSmallBanner,
  [`mi-aem-common-spa/components/content/tileskinny`]: MerchandisingTileSkinny,
  [`mi-aem-account/components/content/loyaltycompass`]: LoyaltyCompassEditable,
  [`mi-aem-account/components/content/trusteddevices`]: TrustedDevicesEditable,
  [`mi-aem-account/components/content/verifiedspecialrates`]: VerifiedSpecialRatesEditable,
  [`mi-aem-account/components/content/walletwidget`]: WalletWidgetEditable,
  [`mi-aem-common-spa/components/content/dcadecisioncontainer`]: DCADecisionContainer,
  ['mi-aem-common-spa/components/content/mangopilot']: MerchandisingMangoPilot,
  [`mi-aem-account/components/content/accountstickyrailcontainer`]: AccountStickyLeftRailContainerEditable,
  [`mi-aem-common-spa/components/content/partnercard`]: MerchandisingPartnerCard,
  ['mi-aem-common-spa/components/content/mangopilot']: RiottMediaCard,
  ['mi-aem-common-spa/components/content/riottmediacard']: RiottMediaCard,
  [`mi-aem-account/components/content/inlinemessaging`]: AccountRefreshNotificationEditable,
};
export const defineComponentMapping = (allowedComponents, pagePath, isAuthorMode, ...args) => {
  const [isDTT, pageProps, featureFlagLogo] = args; // define rest params
  //mi-aem-account/

  MapTo(`mi-aem-account/components/content/walletwidget`)(
    props => <WalletWidgetEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'walletwidget',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/inlinemessaging`)(
    props => <AccountRefreshNotificationEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'inlinemessaging',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/verifiedspecialrates`)(
    props => <VerifiedSpecialRatesEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'verifiedspecialrates',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/loyaltycompass`)(
    props => <LoyaltyCompassEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'Loyalty Compass',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/accountstickyrailcontainer`)(
    props => <AccountStickyLeftRailContainerEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'Account Sticky Component Wrapper',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/trusteddevices`)(
    props => <TrustedDevicesEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'trusteddevices',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/tilesquare`)(
    props => <MerchandisingCardTile {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'Merchandising Tile',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/tilecarouselcontainer`)(
    props => <MerchandisingCarouselContainer {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'Tile Carousel Container',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/merchandisingsmallbanner`)(
    props => <MerchandisingSmallBanner {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'Merchandising Small Banner',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/tileskinny`)(
    props => <MerchandisingTileSkinny {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'Merchandising Tile Skinny',
      isEmpty: false,
    }
  );

  MapTo('mi-aem-common-spa/components/content/mangopilot')(props => {
    return <RiottMediaCard {...props} isAuthorMode={isAuthorMode} />;
  });

  MapTo('mi-aem-common-spa/components/content/riottmediacard')(props => {
    return <RiottMediaCard {...props} isAuthorMode={isAuthorMode} />;
  });

  MapTo(`mi-aem-common-spa/components/content/dcadecisioncontainer`)(
    props => <DCADecisionContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
    {
      emptyLabel: 'DCA Wrapper',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/accordion`)(
    props => <AccordionCardWrapperEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'AccordianCardWrapper',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-groups/components/content/shoppingpages/sectionnavigationv2`)(
    props => <NavigationMenu {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'NavigationMenu',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/accounttable`)(
    props => <AccountTableEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'AccountTable',
      isEmpty: false,
    }
  );
  MapTo(`mcom-book-spa/components/flyoutcontainer`)(
    props => <FlyoutDrawer {...props.model} {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'FlyoutDrawer',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/accountwrapper`)(props => (
    <AccountStaticWrapperEditable {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));

  MapTo(`mi-aem-account/components/content/partnercardwrapper`)(props => (
    <AccountPartnerCardWrapperEditable {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));

  MapTo(`mi-aem-account/components/content/extendedFooter`)(
    props => <ExtendedFooterEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'ExtendedFooter',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/roomPreferences`)(
    props => <RoomPreferencesEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'roomPreferences',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/ambassadorservicedetails`)(
    props => <AmbassadorServiceDetailsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'ambassadorservicedetails',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/combineaccounts`)(
    props => <CombineAccountsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'combineAccounts',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/combineaccountsconsent`)(
    props => <CombineAccountsConsentEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'combineAccountsConsent',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/membersnapshotribbon`)(
    props => <MemberSnapshotRibbonEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'ExtendedFooter',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/onboardingsection`)(
    props => <OnboardingSectionEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'OnboardingSection',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/overviewoffers`)(
    props => <OverviewOffersEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'OverviewOffers',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/newpromotions`)(
    props => <NewPromotionsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'Newpromotions',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/promotionnotavailable`)(
    props => <PromotionNotAvailableEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'PromotionNotAvailable',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/promotionbanner`)(
    props => <PromotionBannerEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'promotionbanner',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/promotiondetails`)(
    props => <PromotionDetailsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'promotiondetails',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/registeredpromotions`)(
    props => <RegisteredPromotionsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'RegisteredPromotions',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/common/staticwrapper`)(
    props => (
      <StaticWrapper
        {...{
          ...props,
          model: {
            ...props.model,
            styleclass: props.model.styleclass || 'fullbleed',
          },
        }}
      />
    ),
    {
      emptyLabel: 'StaticWrapper',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/common/dynamicwrapper`)(
    props => <DynamicWrapper {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'DynamicWrapper',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/brandribbon`)(props => (
    <BrandRibbon {...props} styleclass="container mx-auto" featureFlagLogo={featureFlagLogo} />
  ));
  MapTo(`mi-aem-account/components/content/customtitletext`)(
    props => <CustomTitleTextEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'CustomTexTitle',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/nightsdetail`)(
    props => <NightsDetailEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'NightsDetail',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/sweepstakesenrollment`)(
    props => <SweepstakesEnrollmentEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'sweepstakesenrollment',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/oneclickjoinreservation`)(
    props => <OneClickJoinContainerEditable {...props} isAuthorMode={isAuthorMode} isDTT={isDTT} />,
    {
      emptyLabel: 'OneClickJoinContainer',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/memberStatus`)(
    props => <MemberStatusEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'memberStatus',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/accountNavbar`)(
    props => <AccountNavbarEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'accountNavbar',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/savedHotelsDetails`)(
    props => <SavedHotelsDetailsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'savedHotelsDetails',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/myActivity`)(
    props => <MyActivityEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'myActivty',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/emailunsubscribe`)(
    props => <EmailUnsubscribeEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'emailunsubscribe',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/earnedRewards`)(
    props => <EarnedRewardsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'earnedrewards',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/earningssummary`)(
    props => <EarningsSummaryEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'Earnings Summary',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/missingStayRequest`)(
    props => <ReportMissingStayLinkSectionEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'ReportMissingStayLinkSection',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/missingstayrequestform`)(
    props => <MissingStayRequestFormEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'missingstayrequestform',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/missingstayrequestconfirmation`)(
    props => <ReportMissingStayRequestConfirmationEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'reportMissingStayRequestConfirmation',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/upcomingtrips`)(
    props => <UpcomingTripsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'upcomingtrips',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/cancelledtrips`)(
    props => <CancelledTripsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'cancelledtrips',
    }
  );

  MapTo(`mi-aem-account/components/content/tripsnavigation`)(
    props => <TripsNavigationEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'tripsNavigation',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/findreservation`)(
    props => <FindReservationOverlayEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'findReservation',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/createaccount`)(
    props => <CreateAccountEditable {...props} isAuthorMode={isAuthorMode} isDTT={isDTT} />,
    {
      emptyLabel: 'createaccount',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`)(
    props => <TargetBannerEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'targetBanner',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/signin`)(
    props => <SignInEditable {...props} isAuthorMode={isAuthorMode} isDTT={isDTT} />,
    {
      emptyLabel: 'signin',
    }
  );
  MapTo(`mi-aem-account/components/content/signout`)(
    props => <SignOutEditable {...props} isAuthorMode={isAuthorMode} isDTT={isDTT} />,
    {
      emptyLabel: 'signout',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/signincontentblock`)(
    props => <SignInContentBlockEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'signincontentblock',
    }
  );
  MapTo(`mi-aem-account/components/content/confirmidentity`)(
    props => <ConfirmIdentityEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'confirmidentity',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/accountcontainer`)(
    props => <AccountContainerEditable {...props} isAuthorMode={isAuthorMode} isDTT={isDTT} />,
    {
      emptyLabel: 'accountcontainer',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/activateorforgotform`)(
    props => <ActivateOrForgotFormEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'ActivateOrForgotForm',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/loyaltywidgetcontainer`)(
    props => <LoyaltyWidgetContainerEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'LoyaltyWidgetContainer',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/setpassword`)(
    props => <SetPasswordEditable {...props} isAuthorMode={isAuthorMode} isDTT={isDTT} />,
    {
      emptyLabel: 'setpassword',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/forgotpasswordemailsent`)(
    props => <ForgotPasswordEmailSentEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'forgotpasswordemailsent',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/eaaglobalheader`)(
    props => <GlobalEAAHeaderEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'eaaglobalheader',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/consentform`)(
    props => <ConsentFormEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'consentform',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/signinappbanner`)(
    props => <SignInAppBannerEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'signinappbanner',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/forcechangepassword`)(
    props => <ForceChangePasswordEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'forcechangepassword',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/accountoverviewnotification`)(
    props => <AccountOverviewNotificationEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'accountoverviewnotification',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/hero`)(props => <Hero {...props} isAuthorMode={isAuthorMode} />, {
    emptyLabel: 'hero',
    isEmpty: false,
  });
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalfeature`)(
    props => (
      <div className="aem-GridColumn aem-GridColumn--default--12">
        <div className="container py-lg-4 my-4">
          <CardHorizontalFeature {...props} isAuthorMode={isAuthorMode} styleclass={'color-scheme1'} />
        </div>
      </div>
    ),
    {
      emptyLabel: 'cardhorizontalfeature',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(
    props => (
      <div className="container member-benefits px-0">
        <CardHorizontalMini {...props} isAuthorMode={isAuthorMode} />
      </div>
    ),
    {
      emptyLabel: 'cardhorizontalmini',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/cardlayered`)(
    props => <CardLayered {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'cardlayered',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/cardcarouselcontainer`)(
    props => (
      <div className="aem-GridColumn aem-GridColumn--default--12">
        <div className="container">
          <CardCarouselContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
        </div>
      </div>
    ),
    {
      emptyLabel: 'cardcarouselcontainer',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/cardvertical`)(
    props => <CardVertical {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
    {
      emptyLabel: 'cardvertical',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/tabcontainer`)(
    props => <TabContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
    {
      emptyLabel: 'tabcontainer',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/variablecolumncontainer`)(
    props => (
      <div className="aem-GridColumn aem-GridColumn--default--12">
        <div className="container">
          <VariableColumnContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
        </div>
      </div>
    ),
    {
      emptyLabel: 'variablecolumncontainer',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/richtext`)(props => <RichText {...props} isAuthorMode={isAuthorMode} />, {
    emptyLabel: 'richtext',
    isEmpty: false,
  });

  MapTo(`mi-aem-common-spa/components/content/text`)(props => <Text {...props} isAuthorMode={isAuthorMode} />, {
    emptyLabel: 'text',
    isEmpty: false,
  });

  MapTo(`mi-aem-common-spa/components/content/iconblock`)(
    props => <IconBlock {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'iconblock',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/datablock`)(
    props => <DataBlock {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'datablock',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-shop-spa/components/content/homepagesearch/v1/homepagesearch`)(
    props => (
      <SearchFormEditable
        {...props}
        isAuthorMode={isAuthorMode}
        currentLocale={pageProps.currentLocale}
        isPositionedExternally={true}
        isNonStickyVariant={true}
      />
    ),
    {
      emptyLabel: 'homepagesearch',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-shop-spa/components/content/baselinesearchform/v1/baselinesearchform`)(
    props => (
      <SearchFormEditable
        {...props}
        isAuthorMode={isAuthorMode}
        currentLocale={pageProps.currentLocale}
        isPositionedExternally={true}
        isNonStickyVariant={true}
      />
    ),
    {
      emptyLabel: 'baselinesearchform',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/createaccountconsentform`)(
    props => <CreateAccountConsentsFormEditable {...props} isAuthorMode={isAuthorMode} isDTT={isDTT} />,
    {
      emptyLabel: 'createaccountconsentform',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-homepage-spa/components/content/herobanner`)(props => (
    <HeroBanner {...props} isAuthorMode={isAuthorMode} />
  ));
  // Import not working so temporary solution
  // Need to remove once platform resolves the import issue
  const DataPageVariationConfig = {
    emptyLabel: 'Data Page',

    isEmpty: function (props) {
      return !props || !props.configured;
    },
  };
  MapTo(`mi-aem-account/components/content/profilesection`)(
    props => <ProfileSectionEditable {...props} isAuthorMode={isAuthorMode} isDTT={isDTT} />,
    {
      emptyLabel: 'profilesection',
      isEmpty: false,
    }
  );
  MapTo('mi-aem-account/components/content/datapagecomponent')(props => {
    const gridItems = props?.model?.cqItems?.responsivegrid?.[':items'];
    const isAccountContainer = gridItems ? Object.keys(gridItems)?.[0]?.includes('accountcontainer') : false;

    return (
      <Container
        isInEditor
        {...props}
        isPage={false}
        model={isAccountContainer ? respGridUtil(props?.model?.cqItems?.responsivegrid) : props?.model}
      />
    );
  }, DataPageVariationConfig);

  // Import not working so temporary solution
  // Need to remove once platform resolves the import issue
  const ExperienceFragmentVariationConfig = {
    emptyLabel: 'Experience Fragment',

    isEmpty: function (props) {
      return !props || !props.configured;
    },
  };
  MapTo('mi-aem-common-spa/components/experiencefragment')(props => {
    return (
      <Container
        isInEditor
        {...props}
        isPage={false}
        model={respGridUtil(props?.model?.cqItems?.root?.[':items']?.responsivegrid)}
      />
    );
  }, ExperienceFragmentVariationConfig);

  MapTo(`mi-aem-account/components/content/changepassword`)(
    props => <ChangePasswordEditable {...props} isAuthorMode={isAuthorMode} isDTT={isDTT} />,
    {
      emptyLabel: 'changepassword',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/foodbevpreferences`)(
    props => <FoodBevPreferenceEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'foodBevPreferenceModal',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/editpersonalinformation`)(
    props => <EditPersonalInformationEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'editperonsalinfomodal',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/bannermessages`)(
    props => <BannerMessagesEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'BannerMessages',
    }
  );
  MapTo(`mi-aem-account/components/content/communicationpreference`)(
    props => <CommunicationPreferenceEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'communicationpreference',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/earningandrewards`)(
    props => <EarningAndRewardsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'earningandrewards',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/twostepverification`)(
    props => <TwoStepVerificationEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'twostepverification',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/ambassadorelitepreferences`)(
    props => <AmbassadorElitePreferencesEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'ambassadorelitepreferences',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/foliooptions`)(
    props => <FolioOptionsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'editfoliooptions',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/interestsandhobbies`)(
    props => <InterestsAndHobbiesEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'interestsandhobbies',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/addcard`)(
    props => <AddCardEditable {...props} isAuthorMode={isAuthorMode} isDTT={isDTT} />,
    {
      emptyLabel: 'addcard',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/editchangepassword`)(
    props => <EditChangePasswordEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'editchangepassword',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/modifyupgraderequestheader`)(
    props => <ModifyUpgradeReqHeaderEditable {...props} isAuthorMode={isAuthorMode} isDTT={isDTT} />,
    {
      emptyLabel: 'modifyupgraderequestheader',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/updateroomselection`)(
    props => <UpdateRoomSelectionEditable {...props} isAuthorMode={isAuthorMode} isDTT={isDTT} />,
    {
      emptyLabel: 'UpdateRoomSelection',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/cancelupgraderequest`)(
    props => <CancelUpgradeRequestEditable {...props} isAuthorMode={isAuthorMode} isDTT={isDTT} />,
    {
      emptyLabel: 'cancelupgraderequest',
      isEmpty: false,
    }
  );
  MapTo(`mcom-book-spa/components/foundation/roomdetails`)(
    props =>
      isDTT ? (
        <RoomDetailsModalEditableMGP {...props} isAuthorMode={isAuthorMode} />
      ) : (
        <RoomDetailsModalEditable {...props} isAuthorMode={isAuthorMode} />
      ),
    {
      emptyLabel: 'roomdetails',
      isEmpty: false,
    }
  );
  MapTo(`mcom-book-spa/components/modifyratelistmenu/currentreservationdetails`)(
    props =>
      isDTT ? (
        <CurrentReservationDetailsEditableMGP
          componentClasses="container mx-auto mt-0"
          {...props}
          isAccountPage={true}
          isAuthorMode={isAuthorMode}
        />
      ) : (
        <CurrentReservationDetailsEditable
          componentClasses="container mx-auto mt-0"
          {...props}
          isAccountPage={true}
          isAuthorMode={isAuthorMode}
        />
      ),
    {
      emptyLabel: 'currentreservationdetails',
      isEmpty: false,
    }
  );
  MapTo(`mcom-book-spa/components/prebooking/hotelheader`)(
    props =>
      isDTT ? (
        <HotelHeaderV2EditableMGP
          {...props}
          isAuthorMode={isAuthorMode}
          className="fullbleed m-container-fullbleed color-scheme7"
          isAccountPage={true}
        />
      ) : (
        <HotelHeaderV2Editable
          {...props}
          isAuthorMode={isAuthorMode}
          className="fullbleed m-container-fullbleed color-scheme7"
          isAccountPage={true}
        />
      ),
    {
      emptyLabel: 'hotelheader',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/pointstransfer`)(
    props => <PointsTransferEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'PointsTransfer',
    }
  );
  MapTo(`mcom-book-spa/components/foundation/errormessage`)(
    props => <ErrorMessageEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'errormessage',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/lookupmembernumber`)(
    props => <LookUpMemberNumberEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'lookupmembernumber',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/partnercard`)(
    props => <PartnerCardEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'PartnerCard',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/accountmetrics`)(
    props => <AccountMetricsEditable {...props} isAuthorMode={isAuthorMode} isDTT={isDTT} />,
    {
      emptyLabel: 'AccountMetrics',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/membershipbenefits`)(
    props => <MembershipBenefitsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'MembershipBenefits',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/addgiftcard`)(
    props => <AddGiftCardEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'AddGiftCard',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-account/components/content/viewgiftcard`)(
    props => <ViewGiftCardEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'ViewGiftCard',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/globalnav/global-navigation`)(
    props => <NavigationContainerWrapper {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'NavigationContainerWrapper',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/globalnav/utilityNavigation`)(
    props => <NavigationUtilityLinkWrapper {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'NavigationUtilityLinkWrapper',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/globalnav/primaryNavigation`)(
    props => <NavigationWrapper {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'NavigationWrapper',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/accordioncontainerenhanced`)(props => (
    <AccordionContainerEnhanced {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mcom-book-spa/components/hoteloverlay/hqvmodal`)(
    props =>
      isDTT ? (
        <HQVModalEditableMGP {...props} isAuthorMode={isAuthorMode} />
      ) : (
        <HQVModalEditable {...props} isAuthorMode={isAuthorMode} />
      ),
    {
      emptyLabel: 'hqvmodal',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/partnercard`)(MerchandisingPartnerCard, {
    emptyLabel: 'Partner Card',
    isEmpty: false,
  });
  // Import not working end

  const existingMappings = Object.keys(AEM_REACT_MAPPING);
  if (allowedComponents) {
    allowedComponents.forEach(mapping => {
      const baseModelPath = '/jcr:content/root/responsivegrid/';
      const componentPath = mapping.path.split(baseModelPath)[1];

      if (existingMappings.indexOf(componentPath) === -1) {
        MapTo(componentPath)(EditableHTLWrapper, {
          emptyLabel: mapping.title,
          isEmpty: false,
        });
      } else {
        console.log('mapping exists', componentPath);
      }
    });
  }
};
